import { render, staticRenderFns } from "./LoadSettings.vue?vue&type=template&id=258e87ae"
import script from "./LoadSettings.vue?vue&type=script&lang=ts"
export * from "./LoadSettings.vue?vue&type=script&lang=ts"
import style0 from "./LoadSettings.vue?vue&type=style&index=0&id=258e87ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports